// import Assignment from './Assignment';

export default {
  // component: Assignment,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Assignment" */ './Assignment')),
  permissions: ['360EvaluationMenu/QuestionMenu/QuestionAssignMenu'],
  name: app.translate('routes.home.Assignment'),
  icon: 'account-check',
  drawer: true,
};
